module.exports = __webpack_public_path__ + "img/icon8.654bdfef.jpg";